import { Component, Input } from '@angular/core';
import { Invoice } from '~gc/domains/invoices/invoice/invoice.model';
import { DetailedInvoiceItem } from '~gc/domains/models/detailed-invoice-item';
import { User } from '../../../domains/users';

@Component({
  selector: 'gc-view-invoice-list',
  templateUrl: './view-invoice-list.component.html',
  styleUrls: ['./view-invoice-list.component.scss'],
})
export class ViewInvoiceListComponent {
  @Input() invoice!: Invoice;
  @Input() items?: DetailedInvoiceItem[];
  @Input() user?: User;
  @Input() permissions!: string[];
  @Input() role?: string;
}
